export const SUPPLIER_DYNAMICS_TAB_KEYS = {
  PURCHASE_CHARACTERISTICS: 'purchaseCharacteristics',
  RESOURCES: 'resources',
  NEWS: 'news',
  SUPPLIER_IQ: 'supplierIQ',
  SUPPLIER_RISK: 'supplierRisk',
  NOTES: 'notes'
} as const;

export const LEGACY_PURCHASE_CHARACTERISTICS_TABS = ['about', 'PurchaseCharacteristics'] as const;

export const NPI_SUPPLIER_DYNAMICS_TABS = [
  SUPPLIER_DYNAMICS_TAB_KEYS.PURCHASE_CHARACTERISTICS,
  SUPPLIER_DYNAMICS_TAB_KEYS.RESOURCES,
  SUPPLIER_DYNAMICS_TAB_KEYS.NEWS,
  SUPPLIER_DYNAMICS_TAB_KEYS.SUPPLIER_IQ,
  SUPPLIER_DYNAMICS_TAB_KEYS.SUPPLIER_RISK,
  SUPPLIER_DYNAMICS_TAB_KEYS.NOTES
] as const;

export const normalizeSupplierDynamicsTab = (tab?: string | null): string | undefined => {
  if (!tab) {
    return undefined;
  }

  if (LEGACY_PURCHASE_CHARACTERISTICS_TABS.includes(tab as (typeof LEGACY_PURCHASE_CHARACTERISTICS_TABS)[number])) {
    return SUPPLIER_DYNAMICS_TAB_KEYS.PURCHASE_CHARACTERISTICS;
  }

  return tab;
};
